export default "/images/ic-mapping-a.svg?57913c2de0f7a19c94d2bb97cd5b0262";